import styled from '@emotion/styled';
import { Popover, Tag, Tooltip, Typography } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { TRY_THEN_BUY } from '../../../constants/define/translation';
import { appStyles } from '../../../styles';
import { TTBStatus } from '../../../types/tryThenBuy';
import { ContentReason } from '../ttb/columns/PauseColumn';

interface StatusColumnProps {
  status: string;
  isActive?: boolean;
  width?: string;
  minLength?: number;
  record?: any;
}
const ContentCancelReason = (props: any) => {
  const { cancelReason } = props;
  return (
    <StyledContentCancelReason>
      <div className="wrap-popover">
        <p className="nodes-value">{cancelReason}</p>
      </div>
    </StyledContentCancelReason>
  );
};

const PopoverTitle = (props: any) => {
  return <span style={{ fontSize: 16, fontWeight: 'bold' }}>{props.title}</span>;
};
export default React.memo((props: StatusColumnProps) => {
  const { t } = useTranslation(TRY_THEN_BUY);
  const { isActive, width, minLength, record } = props;
  let { status } = props;

  if (!status) {
    return (
      <StyledContainer>
        <Tag color="#EEEEEE" className="default">
          TBD
        </Tag>
      </StyledContainer>
    );
  }
  const isPaused = record?.paused === true;
  status = isPaused ? `${TTBStatus.PAUSED} - ${status}` : status;
  const minLengthDisplay = minLength || 17;
  if (status.length <= minLengthDisplay) {
    return (
      <StyledContainer>
        <Tag
          color={isActive ? '#00BE4B' : '#EEEEEE'}
          className={isActive ? 'active' : 'default'}
          style={{ width: width || '120px' }}
        >
          {record?.cancelReason ? (
            <Popover
              content={<ContentCancelReason cancelReason={record.cancelReason} />}
              title={<PopoverTitle title={t('form.cancelReason')} />}
              className="popover-info"
            >
              <Typography.Text>{status}</Typography.Text>
            </Popover>
          ) : (
            status
          )}
        </Tag>
      </StyledContainer>
    );
  }
  const renderStatus = (
    statusValue: string,
    isRenderCancel: any,
    isRenderPause?: boolean,
    pauseReason?: any,
    cancelReason?: any,
  ) => {
    if (isRenderCancel) {
      return (
        <Popover
          content={<ContentCancelReason cancelReason={cancelReason} />}
          title={<PopoverTitle title={t('form.cancelReason')} />}
          className="popover-info"
        >
          <Typography.Text>{statusValue}</Typography.Text>
        </Popover>
      );
    }
    if (isRenderPause) {
      return (
        <Popover
          content={<ContentReason reason={pauseReason} />}
          title={<PopoverTitle title={t('form.pauseReason')} />}
          className="popover-info"
        >
          <Typography.Text>{statusValue}</Typography.Text>
        </Popover>
      );
    }
    return statusValue;
  };
  return (
    <StyledContainer>
      <Tag
        color={isActive ? '#00BE4B' : '#EEEEEE'}
        className={isActive ? 'active' : 'default'}
        style={{ width: width || '120px' }}
      >
        <Tooltip placement={isPaused || record?.cancelReason ? 'left' : 'top'} title={status}>
          {renderStatus(
            `${status.substring(0, 16)}...`,
            record?.cancelReason,
            isPaused,
            record?.pauseReason,
            record?.cancelReason,
          )}
        </Tooltip>
      </Tag>
    </StyledContainer>
  );
});

const StyledContainer = styled.div`
  .ant-tag {
    mim-width: 120px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
    font-weight: 600;
    border-radius: 0;
    font-size: 12px;
    &.default {
      ${appStyles.color.black}
    }
  }
`;
const StyledContentCancelReason = styled.div`
  .wrap-popover {
    max-width: 600px;
  }
  p {
    margin-bottom: 0;
    font-size: 13px;
  }

  & .nodes-value {
    color: #97979d;
    font-weight: 600;
  }

  & .nodes-name {
    font-weight: 700;
  }
`;
